
import { Label } from "@/components/ui/label";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HtmlBlockConfiguration } from "@/types/block-configurations";
import { ResponsiveControls } from "../shared";

interface HtmlBlockPropertiesProps {
  config: HtmlBlockConfiguration;
  onChange: (config: HtmlBlockConfiguration) => void;
}

export function HtmlBlockProperties({ config, onChange }: HtmlBlockPropertiesProps) {
  const updateField = <K extends keyof HtmlBlockConfiguration>(
    field: K,
    value: HtmlBlockConfiguration[K]
  ) => {
    onChange({ ...config, [field]: value });
  };

  return (
    <div className="space-y-3">
      <div>
        <Label className="text-xs font-medium mb-1 block">HTML Content</Label>
        <textarea
          value={config.content}
          onChange={(e) => updateField('content', e.target.value)}
          placeholder="<p>Enter your custom HTML here...</p>"
          rows={10}
          spellCheck={false}
          className="w-full rounded-md border border-input bg-background px-3 py-2 text-xs font-mono resize-y focus:outline-none focus:ring-2 focus:ring-ring"
        />
        <p className="text-xs text-muted-foreground mt-1">
          HTML is inserted directly into the email. Inline styles only — external stylesheets and scripts are stripped by most email clients.
        </p>
      </div>

      <Accordion type="multiple" className="w-full">
        <AccordionItem value="responsive">
          <AccordionTrigger>Responsive</AccordionTrigger>
          <AccordionContent>
            <ResponsiveControls
              value={config.responsive}
              onChange={(responsive) => updateField('responsive', responsive)}
            />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
